import './scss/style.scss'
import 'react-toastify/dist/ReactToastify.css';
import { Routing } from './components'
import { bootstrapAuth } from './services/Authentication/BootstrapAuth';
import { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectAuth, setAuthStatus } from './features/authSlice';
import { AUTH_HINT, AUTH_STATUS_GUEST, AUTH_STATUS_LOADING } from './Constant';
import { Store } from './app/store';
import Loader from './components/Layout/Loader';
function App() {
  const auth = useSelector(selectAuth);
  useEffect(() => {
    const hint = localStorage.getItem(AUTH_HINT);
    if (!hint) {
      Store.dispatch(setAuthStatus(AUTH_STATUS_GUEST));
      return;
    }
    bootstrapAuth();
  }, []);
  if (auth.status === AUTH_STATUS_LOADING) {
    return (
      <div className="white-screen-loader">
        <Loader />
      </div>
    );
  }

  return (
    <BrowserRouter>
        <Routing/>
    </BrowserRouter>
  )
}

export default App
